import { Text } from '@/components/_rebrand/Text';
import cn from 'classnames';

export const ComingSoonOverlay = () => {
  return (
    <div aria-disabled className="flex flex-col gap-3 cursor-default select-none">
      <span className={cn('rounded-[64px] flex items-center gap-2 bg-white py-xs px-lg ')}>
        <Text type="p2-medium" className="text-black">
          Coming soon
        </Text>
      </span>
    </div>
  );
};
